import { WarningRegular } from "@/pages/taskpane/components/icons/IconCustom";
import { PreSelectedResourceInfo } from "@/pages/taskpane/shared/types/preSelectedResource";
import React from "react";
import { useTranslation } from "react-i18next";
import SelectMeetingType from "../../resources/components/SelectMeetingType";
import { useMeetingType } from "../hooks/useMeetingType";

type Props = {
  notifyInfo?: PreSelectedResourceInfo;
};

const MeetingType = ({ notifyInfo }: Props) => {
  const { t } = useTranslation();
  const { onSelectMeetingType } = useMeetingType();

  const onRemoveItem = () => {
    if (notifyInfo) {
      onSelectMeetingType(notifyInfo);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex gap-2">
        <div>
          <WarningRegular />
        </div>
        <div className="flex flex-col gap-2 w-[100%]">
          <span className="mb-6 text-sm font-medium text-gray-900 dark:text-white">
            {t("Your must select a Meeting label")}
          </span>
          <SelectMeetingType onRemoveNotify={onRemoveItem} />
        </div>
      </div>
    </div>
  );
};

export default MeetingType;
